import { Component, ElementRef, Renderer2, Directive, Input } from '@angular/core';
export type BpCardImageDisplayType = 'cap' | 'background';

@Component({
  selector: 'bp-card',
  exportAs: 'bpCard',
  template: `<ng-content></ng-content>`
})
export class BpCardComponent {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'card');
  }
}

@Component({
  selector: 'bp-card-body',
  exportAs: 'bpCardBody',
  template: `<ng-content></ng-content>`
})
export class BpCardBodyComponent {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'card-body');
  }
}

@Component({
  selector: 'bp-card-header',
  exportAs: 'bpCardHeader',
  template: `<ng-content></ng-content>`
})
export class BpCardHeaderComponent {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'card-header');
  }
}

@Component({
  selector: 'bp-card-footer',
  exportAs: 'bpCardFooter',
  template: `<ng-content></ng-content>`
})
export class BpCardFooterComponent {
  constructor(private el: ElementRef, private renderer: Renderer2) {
     this.renderer.addClass(this.el.nativeElement, 'card-footer');
  }
}
@Directive({
  selector: '[bpCardTitle]',
  exportAs: 'bpCardTitle',
})
export class BpCardTitleDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'card-title');
  }
}

@Directive({
  selector: '[bpCardSubtitle]',
  exportAs: 'bpCardSubtitle',
})
export class BpCardSubtitleDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'card-subtitle');
  }
}

@Directive({
  selector: '[bpCardText]',
  exportAs: 'bpCardText',
})
export class BpCardTextDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'card-text');
  }
}

@Directive({
  selector: '[bpCardImage]',
  exportAs: 'bpCardImagee',
})
export class BpCardImageDirective {
  private displayCss: string;
  private disp: BpCardImageDisplayType;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.display = 'cap';
  }

  @Input() set display(value: BpCardImageDisplayType) {
    if (value !== 'cap' && value !== 'background') {
      console.log('bpCardImage has invalid position');
    }

    if (this.displayCss) {
      this.renderer.removeClass(this.el.nativeElement, this.displayCss);
    }

    this.disp = value;
    this.displayCss = value === 'cap' ? 'card-img-top' : 'card-img';
    this.renderer.addClass(this.el.nativeElement, this.displayCss);
  }

  get display() {
    return this.disp;
  }
}

@Component({
  selector: 'bp-card-image-overlay, bp-card-img-overlay',
  exportAs: 'bpCardImageOverlay',
  template: `<ng-content></ng-content>`
})
export class BpCardImageOverlayComponent {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'card-img-overlay');
  }
}
